import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "note-suggested-actions" }
const _hoisted_2 = {
  key: 0,
  class: "p-4 text-center text-inactive-text box-border"
}
const _hoisted_3 = {
  key: 1,
  class: "note-suggested-actions-wrap"
}

import NoteSuggestedAction from '@/components/notes/NoteSuggestedAction';
import useTranslate from '@/utilities/composables/useTranslate';
import { PropType } from 'vue';
import { AIGeneratedAction } from '@superthread-com/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'NoteSuggestedActions',
  props: {
  suggestedActions: {
    type: Array as PropType<AIGeneratedAction[]>,
    required: true,
    default: () => [],
  },
},
  emits: ['accept', 'reject'],
  setup(__props, { emit: __emit }) {

const { translate } = useTranslate();



const emit = __emit;

const handleAccept = (action: any) => {
  emit('accept', action);
};

const handleReject = (action: any) => {
  emit('reject', action);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.suggestedActions.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(translate)('noSuggestedActions')), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.suggestedActions, (action) => {
            return (_openBlock(), _createBlock(_unref(NoteSuggestedAction), {
              key: action.id,
              action: action,
              onAccept: handleAccept,
              onReject: handleReject
            }, null, 8, ["action"]))
          }), 128))
        ]))
  ]))
}
}

})